import { FC, memo } from 'react';
import { Link } from 'react-router-dom';
import { useTranslate } from 'hooks/useTranslate';

import EnvelopesBannerImage from 'assets/images/cards-group.svg';

const EnvelopesListBanner: FC = () => {
  const { t } = useTranslate();

  return (
    <div className="nk-block my-5">
      <div className="card card-bordered hover-shadow">
        <div className="card-inner card-inner-lg">
          <div className="nk-help">
            <div className="nk-help-img">
              <img
                src={EnvelopesBannerImage}
                alt="Envelopes list"
                width={116}
                height={116}
              />
            </div>

            <div className="nk-help-text">
              <h5>{t('ManagesEnvelopes')}</h5>
              <p className="text-soft">{t('EnvelopesBannerText')}</p>
            </div>

            <div className="nk-help-action">
              <Link to="/contacto" className="btn btn-lg btn-outline-primary">
                {t('MoreInfo')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(EnvelopesListBanner);
